// Get Category
export const GET_CATEGORY = "GET_CATEGORY"
export const GET_CATEGORY_SUCCESS = "GET_CATEGORY_SUCCESS"

// SAVE Gategory
export const SAVE_UPLOAD_GATEGORY = "SAVE_UPLOAD_GATEGORY"
export const SAVE_UPLOAD_GATEGORY_SUCCESS = "SAVE_UPLOAD_GATEGORY_SUCCESS"
export const SAVE_UPLOAD_GATEGORY_ERROR = "SAVE_UPLOAD_GATEGORY_ERROR"

// ADD NEW USER
export const CATEGORY_USER = "CATEGORY_USER"
export const CATEGORY_USER_SUCCESS = "CATEGORY_USER_SUCCESS"
export const CATEGORY_USER_ERROR = "CATEGORY_USER_ERROR"

// ADD NEW SUB-CATEGORY
export const SUB_CATEGORY = "SUB_CATEGORY"
export const SUB_CATEGORY_SUCCESS = "SUB_CATEGORY_SUCCESS"
export const SUB_CATEGORY_ERROR = "SUB_CATEGORY_ERROR"


//DELETE CAEGORY USER 
export const DELETE_CATEGORY_USER = "DELETE_CATEGORY_USER"
export const DELETE_CATEGORY_USER_SUCCESS = "DELETE_CATEGORY_USER_SUCCESS"
export const DELETE_CATEGORY_USER_ERROR = "DELETE_CATEGORY_USER_ERROR"

//GET USERS
export const GET_USER_BY_PROJECT = " GET_USER_BY_PROJECT"
export const GET_USER_BY_PROJECT_SUCCESS = " GET_USER_BY_PROJECT_SUCCESS"
export const GET_USER_BY_PROJECT_ERROR = " GET_USER_BY_PROJECT_ERROR"

//ADD USERS
export const CREATE_USERS_FOR_PROJECTS = "CREATE_USERS_FOR_PROJECTS"

//GET AGENTS
export const GET_ALL_AGENT_DATAILS = "GET_ALL_AGENT_DATAILS"
export const GET_AGENT_SUCCESS = "GET_AGENT_SUCCESS"
export const GET_ALL_BILLING_TYPES_SUCCESS = "GET_ALL_BILLING_TYPES_SUCCESS"
export const GET_ALL_BILLING_TYPES = "GET_ALL_BILLING_TYPES"
// 
export const CATEGORY_USER_CATEGORY_LINK = "CATEGORY_USER_CATEGORY_LINK"
export const CATEGORY_USER_CATEGORY_LINK_SUCCESS = "CATEGORY_USER_CATEGORY_LINK_SUCCESS"
export const CATEGORY_USER_CATEGORY_LINK_ERROR = "CATEGORY_USER_CATEGORY_LINK_ERROR"

// get method for project status
export const GET_PROJECT_STATUS = " GET_PROJECT_STATUS"
export const GET_PROJECT_STATUS_SUCCESS = " GET_PROJECT_STATUS_SUCCESS"
export const GET_PROJECT_STATUS_ERROR = " GET_PROJECT_STATUS_ERROR"

// get method for project status total hours
export const GET_PROJECT_STATUS_TOTAL_HOURS = " GET_PROJECT_STATUS_TOTAL_HOURS"
export const GET_PROJECT_STATUS_TOTAL_HOURS_SUCCESS = " GET_PROJECT_STATUS_TOTAL_HOURS_SUCCESS"
export const GET_PROJECT_STATUS_TOTAL_HOURS_ERROR = " GET_PROJECT_STATUS_TOTAL_HOURS_ERROR"
